import React from "react";
import { helpId, } from "@rjsf/utils";
/** The `FieldHelpTemplate` component renders any help desired for a field
 *
 * @param props - The `FieldHelpProps` to be rendered
 */
export default function FieldHelpTemplate(props) {
    const { idSchema, help, hasErrors } = props;
    if (!help) {
        return null;
    }
    const id = helpId(idSchema);
    return (React.createElement("span", { className: hasErrors ? "text-red-500" : "text-muted-foreground", id: id }, help));
}
//# sourceMappingURL=FieldHelpTemplate.js.map